"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCovereageSelector = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCovereageSelector = _styledComponents.default.div.withConfig({
  displayName: "CoverageSelectorstyles__StyledCovereageSelector",
  componentId: "sc-1v9c7hz-0"
})(["margin:0 .25rem;white-space:nowrap;&,& *{font-family:", ";font-weight:", ";}&:last-child{margin-right:0;}&:first-child{margin-left:0;}.c-coverage-selector-checkbox-button{display:block;font-size:.75rem;letter-spacing:0.05rem;margin:", " auto;min-width:6.75rem;padding:.5rem;text-align:left;&:active .c-coverage-selector-divider{background-color:", ";}@media only screen and (min-width:", "){max-width:30rem;}}.c-coverage-selector-layout-container{text-align:center;}.c-coverage-selector-divider{background-color:", ";margin:.2rem 0 .3rem 0;&.c-coverage-selector-checked{background-color:", ";}@media only screen and (min-width:", "){width:100%;}}.c-coverage-selector-incident-amount,.c-coverage-selector-employee-amount,.c-coverage-selector-policy-limit{font-size:1.5rem;}&.c-coverage-selector-vertical{margin:", " auto 0 auto;&:last-child{margin:", " auto;}.c-coverage-selector-checkbox-button{align-items:flex-start;display:flex;flex-direction:row;font-size:1rem;margin:0 auto;}.c-coverage-selector-layout-container{margin:0 1rem;}.c-coverage-selector-title-block{margin-top:.4rem;}.c-coverage-selector-divider{margin:.2rem 0 .5rem 0;}.c-coverage-selector-coverage-container{display:flex;flex-direction:row;width:min-content;margin:0 auto;}.c-coverage-selector-coverage-block{margin:0 1rem;}}"], function (props) {
  return props.theme.primaryFont;
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.c_foreground_overDark;
}, function (props) {
  return props.theme.mediumBreak;
}, function (props) {
  return props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.c_foreground_overDark;
}, function (props) {
  return props.theme.mediumBreak;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledCovereageSelector = StyledCovereageSelector;